import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size?: number;
  color?: string;
};

const LocationFill = ({ size = 16, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00006 1.50001C6.57752 1.48131 5.20569 2.02786 4.18575 3.01967C3.16582 4.01149 2.58113 5.3675 2.56006 6.79001C2.68992 8.27104 3.18465 9.69684 4.00006 10.94C5.16078 12.5463 6.459 14.0487 7.88006 15.43C7.92463 15.4722 7.98368 15.4957 8.04506 15.4957C8.10644 15.4957 8.16549 15.4722 8.21006 15.43C9.58466 14.0587 10.8486 12.5807 11.9901 11.01C12.7966 9.73555 13.3091 8.29736 13.4901 6.80001C13.4433 5.37631 12.844 4.02678 11.8191 3.03742C10.7943 2.04807 9.42452 1.49664 8.00006 1.50001ZM8.00006 8.66001C7.67174 8.66001 7.3508 8.56265 7.07781 8.38025C6.80483 8.19784 6.59206 7.93859 6.46642 7.63526C6.34078 7.33194 6.3079 6.99817 6.37195 6.67616C6.43601 6.35415 6.59411 6.05836 6.82626 5.82621C7.05842 5.59405 7.3542 5.43595 7.67621 5.3719C7.99822 5.30785 8.33199 5.34073 8.63531 5.46637C8.93864 5.59201 9.1979 5.80477 9.3803 6.07776C9.5627 6.35075 9.66006 6.67169 9.66006 7.00001C9.66006 7.218 9.61712 7.43386 9.5337 7.63526C9.45028 7.83666 9.328 8.01966 9.17386 8.1738C9.01971 8.32795 8.83671 8.45022 8.63531 8.53365C8.43391 8.61707 8.21805 8.66001 8.00006 8.66001Z"
        fill={color}
      />
    </svg>
  );
};

export default LocationFill;
